import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadModality () {
    const api = getApiClient(this.$store)
    const modalityId = this.$route.params.id

    api.get(`modalities/${modalityId}`)
      .then(result => {
        this.modality = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.modality.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'modalities'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.modality['@id']
    }

    const payload = this.modality
    if (!payload.icon.match(/data:image\/svg\+xml;base64,/g)) {
      delete payload.icon
    }

    api[method](endpoint, payload, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Modalidade salva com sucesso')
        this.$router.push({
          name: 'Modalities',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar modalidade')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
